import Image from "next/image";

export function ProductCardImage({ featuredImage }: ProductCardImageProps) {
  const src = featuredImage.url ?? "";
  return (
    <div className="bg-greyscale-background relative flex min-w-0 flex-1 shrink items-center justify-center overflow-hidden">
      <Image
        src={src}
        alt={featuredImage.alt ?? ""}
        width={540}
        height={540}
        className="m-auto h-full w-full object-cover"
      />
    </div>
  );
}

export type ProductCardImageProps = {
  featuredImage: { url: string | null; alt?: string | null };
};
